import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ContextProvider from './context/Context.jsx';
import ThemeProvider from './context/ThemeContext.jsx';
import AppErrorBoundary from './components/AppErrorBoundary.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ContextProvider>
        {/* Inside the provider: the fallback reads the language and the session notices stay mounted. */}
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </ContextProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
